module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-appbar', {
    staticClass: "bgClass",
    attrs: {
      "titleClass": "appbarTitle"
    }
  }, [_c('mu-text-field', {
    staticStyle: {
      "margin": "0px 20px 0 30px"
    },
    attrs: {
      "slot": "left",
      "underlineShow": false,
      "hintText": _vm.hintDesc,
      "hintTextClass": "textField",
      "inputClass": "input-style"
    },
    slot: "left",
    model: {
      value: (_vm.search.keyword),
      callback: function($$v) {
        _vm.$set(_vm.search, "keyword", $$v)
      },
      expression: "search.keyword"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "btnSearchClass",
    attrs: {
      "slot": "left",
      "color": "#0a81e9",
      "label": "搜索"
    },
    on: {
      "click": _vm.searchKeyword
    },
    slot: "left"
  }), _vm._v(" "), (_vm.showCount) ? _c('div', {
    staticClass: "training-wrapper"
  }, [_c('div', {
    staticClass: "training-content"
  }, [_c('div', {
    staticClass: "training-title"
  }, [_vm._v("您有一个正在进行中的训练")]), _vm._v(" "), _c('div', {
    staticClass: "training-name"
  }, [_vm._v("患者："), _c('span', [_vm._v(_vm._s(_vm.trainName))])]), _vm._v(" "), _c('div', {
    staticClass: "training-time"
  }, [_vm._v("时间："), _c('span', [_vm._v(_vm._s(_vm.trainTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-wrapper",
    on: {
      "click": _vm.toTrain
    }
  }, [_c('mu-icon', {
    staticClass: "toTrain-icon",
    attrs: {
      "value": "keyboard_arrow_right",
      "size": 50
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showNew) ? _c('mu-raised-button', {
    staticClass: "btnNewbuild",
    attrs: {
      "slot": "right",
      "label": _vm.labelFlag,
      "primary": ""
    },
    on: {
      "click": _vm.buildNewOrder
    },
    slot: "right"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07e4c280!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/searchBar.vue
// module id = 942
// module chunks = 2